module.exports = __webpack_public_path__ + "media/images/brand/lander/left-iceberg-2960dfd9c04d47144483a196bb4827c0.svg";